<section class="mt-lg-5">
    <!--Grid row-->
    <div class="row">
        <!--Grid column-->
        <div class="col-xl-3 col-md-6 mb-r">
            <!--Card Primary-->
            <mdb-card bgColor="primary-color" class="classic-admin-card">
                <mdb-card-body>
                    <div class="pull-right">
                        <mdb-icon far icon="money-bill-alt"></mdb-icon>
                    </div>
                    <p class="white-text">SALES</p>
                    <h4>
                        <strong>$2000</strong>
                    </h4>
                </mdb-card-body>
                <div class="progress">
                    <div class="progress-bar bg grey darken-3" role="progressbar" style="width: 25%" aria-valuenow="25"
                         aria-valuemin="0" aria-valuemax="100"></div>
                </div>
                <div class="card-body">
                    <p>Better than last week (25%)</p>
                </div>
            </mdb-card>
            <!--/.Card Primary-->
        </div>
        <!--Grid column-->
        <!--Grid column-->
        <div class="col-xl-3 col-md-6 mb-r">
            <!--Card Warning-->
            <mdb-card bgColor="warning-color" class="classic-admin-card">
                <mdb-card-body>
                    <div class="pull-right">
                        <mdb-icon fas icon="chart-line"></mdb-icon>
                    </div>
                    <p>SUBSCRIPTIONS</p>
                    <h4>
                        <strong>200</strong>
                    </h4>
                </mdb-card-body>
                <div class="progress">
                    <div class="progress-bar bg grey darken-3" role="progressbar" style="width: 25%" aria-valuenow="25"
                         aria-valuemin="0" aria-valuemax="100"></div>
                </div>
                <div class="card-body">
                    <p>Worse than last week (25%)</p>
                </div>
            </mdb-card>
            <!--/.Card Warning-->
        </div>
        <!--Grid column-->
        <!--Grid column-->
        <div class="col-xl-3 col-md-6 mb-r">
            <!--Card Blue-->
            <mdb-card bgColor="light-blue" class="classic-admin-card lighten-1">
                <mdb-card-body>
                    <div class="pull-right">
                        <mdb-icon fas icon="chart-pie"></mdb-icon>
                    </div>
                    <p>TRAFFIC</p>
                    <h4>
                        <strong>20000</strong>
                    </h4>
                </mdb-card-body>
                <div class="progress">
                    <div class="progress-bar bg grey darken-3" role="progressbar" style="width: 75%" aria-valuenow="75"
                         aria-valuemin="0" aria-valuemax="100"></div>
                </div>
                <div class="card-body">
                    <p>Better than last week (75%)</p>
                </div>
            </mdb-card>
            <!--/.Card Blue-->
        </div>
        <!--Grid column-->
        <!--Grid column-->
        <div class="col-xl-3 col-md-6 mb-r">
            <!--Card Red-->
            <mdb-card bgColor="red" class="classic-admin-card accent-2">
                <mdb-card-body>
                    <div class="pull-right">
                        <mdb-icon fas icon="chart-bar"></mdb-icon>
                    </div>
                    <p>ORGANIC TRAFFIC</p>
                    <h4>
                        <strong>2000</strong>
                    </h4>
                </mdb-card-body>
                <div class="progress">
                    <div class="progress-bar bg grey darken-3" role="progressbar" style="width: 25%" aria-valuenow="25"
                         aria-valuemin="0" aria-valuemax="100"></div>
                </div>
                <div class="card-body">
                    <p>Better than last week (25%)</p>
                </div>
            </mdb-card>
            <!--/.Card Red-->
        </div>
        <!--Grid column-->
    </div>
    <!--Grid row-->
</section>
